import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef5ce89c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col mt-4"
}

import { IonContent, popoverController, useIonRouter } from '@ionic/vue';
import { ComputedRef, computed } from 'vue';
import { useI18n } from 'vue-i18n';
//Composables
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
//Components
import AButton from "@/components/Base/AButton";
import User from '@/models/user';

//Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeProjectPopover',
  setup(__props) {

const store = useStore()
const { user } = useUser();
const router = useIonRouter();
const { t } = useI18n({ useScope: 'global' })

//Computed Variables
const currentProject = computed(() => store.state.user.currentUserProject);
const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();

  return currentUser ? currentUser.organisationPrefix : "";
});
//Methods
function dismiss() {
  popoverController.dismiss();
}

function goToChangeProject() {
  router.push('/project-selection')
  dismiss();
}

return (_ctx: any,_cache: any) => {
  return (_unref(user))
    ? (_openBlock(), _createBlock(_unref(IonContent), {
        key: 0,
        class: "ion-padding",
        style: {"background":"white"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('userProject.organization')) + ": " + _toDisplayString(_unref(user).organisation.name), 1),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)(`${organisationPrefix.value}userProject.projectName`)) + ": " + _toDisplayString(currentProject.value?.name), 1)
          ]),
          (_unref(user).organisation.projects.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(AButton), {
                  "data-cy": "button-project",
                  "btn-primary": true,
                  class: "mb-2",
                  expand: true,
                  onClick: goToChangeProject
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('userProject.changeProject')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})